"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumRuntimeEnv = exports.EnumEnv = exports.EnumLevel = void 0;
var EnumLevel;
(function (EnumLevel) {
    EnumLevel["INFO"] = "INFO";
    EnumLevel["ERROR"] = "ERROR";
})(EnumLevel = exports.EnumLevel || (exports.EnumLevel = {}));
;
// 环境变量
var EnumEnv;
(function (EnumEnv) {
    EnumEnv["DEV"] = "DEV";
    EnumEnv["TEST"] = "TEST";
    EnumEnv["PROD"] = "PROD";
    EnumEnv["PRO"] = "PROD";
})(EnumEnv = exports.EnumEnv || (exports.EnumEnv = {}));
// 运行在什么APP下
var EnumRuntimeEnv;
(function (EnumRuntimeEnv) {
    EnumRuntimeEnv["WX"] = "WX";
    EnumRuntimeEnv["WINDOW"] = "WINDOW";
})(EnumRuntimeEnv = exports.EnumRuntimeEnv || (exports.EnumRuntimeEnv = {}));
